import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function DobIcon(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <Circle cx={20} cy={20} r={20} fill={props?.bg ?? "#EBF2FF"} />
            <Path
                d="M12.5 30c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05V13c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h1.625v-.725c0-.217.075-.4.225-.55a.779.779 0 01.575-.225c.233 0 .43.075.587.225.159.15.238.342.238.575v.7h8.5v-.725c0-.217.075-.4.225-.55A.779.779 0 0125.05 10c.233 0 .43.075.587.225.159.15.238.342.238.575v.7H27.5c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v15.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15zm0-1.5h15V17.75h-15V28.5zm0-12.25h15V13h-15v3.25zm0 0V13v3.25z"
                fill={props?.color ?? "#2D57D9"}
            />
        </Svg>
    )
}

export default DobIcon
